import { useEffect, useState, useMemo, useContext } from "react";
import PopOutModal from "./PopOutModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import {UserContext} from '../Common/UserContext';
import UserContext from "../Common/UserContext";
import { toast } from "react-toastify";
import "../styles/ClinicalAuditReviewForm.css";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import SmartToyRoundedIcon from "@mui/icons-material/SmartToyRounded";
import { useHistory } from "react-router-dom";
import menus from "../../user-config.json";
// import {RobotIconSVG} from '/img/rebuttal_robot.svg';
// import RebuttalRobotSvg from './assets/rebuttal_robot.svg';
import { ReactComponent as RebuttalRobotSvg } from "./../../assets/rebuttal_robot.svg";
// import {Robo}
import { ReactComponent as RebuttalUserSvg } from "./../../assets/user_rebuttal.svg";
import moment from "moment";
import Api_Call from "../../ApiCall";

let dataRebuttal = [];
let dataForUpdateRebuttal = [];
let flag = 1;
function Rebuttal({
  isOpen,
  onClose,
  questionsFromAuditData,
  dataToPass,
  onSubmitHandler,
  modalClose,
  buttonAreYouSure,
  setButtonAreYouSureToFalse,
  isViewRebuttalactive,
  setIsViewRebuttalactive,
  showViewRebuttal,
  statusOfRebuttalPopup,
  isYesButtonClicked,
}) {
  console.log(dataRebuttal);
  const { userRole: user, setUser, userId } = useContext(UserContext);
  const [handleClicked, setHandleClicked] = useState(false);

  // if(!user)
  // {
  //   return new Error("type of User is not defined")
  // }

  // const [dataRebuttal,setDataRebuttal]=useState([]);
  console.log(dataToPass);

  console.log(Object.keys(dataToPass));
  useEffect(() => {
    console.log("hi inside");
    if (isYesButtonClicked) {
      dataRebuttal = [];
    }
  }, [isYesButtonClicked]);

  const questionDetails = Object.keys(dataToPass).flatMap((question) => {
    return Object.keys(dataToPass[question])
      .map((subQuestion) => {
        if (typeof dataToPass[question][subQuestion] === "object") {
          // console.log(dataToPass[question][subQuestion]['Question_ID'], question, subQuestion);

          return {
            question_id: dataToPass[question][subQuestion]["Question_ID"],
            subQuestion: subQuestion,
            question: question,
          };
        }
      })
      .filter((value) => value !== undefined);
  });

  console.log(questionDetails);

  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOptionForSubQuestion, setSelecedOptionForSubQuestion] =
    useState("");
  const [subQuestions, setSubQuestions] = useState([]);

  const [selectedRadioOption, setSelectedRadioOption] = useState("");
  const [selectError, setSelectError] = useState("");

  const [flag, setflag] = useState(1);

  const [rebuttalDetails, setRebuttalDetails] = useState([]);
  const [sisterComment, setSisterComment] = useState("");
  const [supervisorComment, setSupervisorComment] = useState("");
  const [auditorComment, setAuditorComment] = useState("");

  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [isSubmitclicked, setIsSubmitclicked] = useState(false);

  const [questionComment, setQuestionComment] = useState("");

  const [isModalClosed, setIsModalClosed] = useState(false);

  const [viewRebuttalData, setViewRebuttalData] = useState();
  const [isViewRebuttalDataEmpty, setIsViewRebuttalDataEmpty] = useState(true);

  const [viewQuestions, setViewQuestions] = useState([]);

  const [viewQs, setViewQs] = useState([]);

  const [rebuttalFiledOnInUpdate, setRebuttalFiledOnInUpdate] = useState("");

  const [dateOnly, setDateOnly] = useState("");

  const [dataForView, setDataForView] = useState();
  const [sisterRebuttalRaisedOnUpdate, setSisterRebuttalRaisedOnUpdate] =
    useState("");
  const [
    supervisorRebuttalRaisedOnUpdate,
    setSupervisorRebuttalRaisedOnUpdate,
  ] = useState("");
  const [auditorRebuttalRaisedOnUpdate, setAuditorRebuttalRaisedOnUpdate] =
    useState("");
  const [rebuttalRaisedBy, setRebuttalRaisedBy] = useState("");
  const [rebuttalRaisedByWhichType, setRebuttalRaisedByWhichType] =
    useState("");

  const [valueFromDropDownAuditor, setValueFromDropDownAuditor] = useState("");
  const [disputeID, setDisputeID] = useState("");
  const [disputeStatus, setDisputeStatus] = useState("");
  const [raisedOn, setRaisedOn] = useState("");

  const history = useHistory();

  //  console.log("--------",selectedOption)
  //  console.log("=======",selectedOptionForSubQuestion)
  //  console.log(">>>>>>>>>",selectedRadioOption)

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    //    setSelecedOptionForSubQuestion('');
    //    setSelectedRadioOption(null);

    //   alert('Selected option: ' + value);
    // Add your custom logic here
  };

  if (buttonAreYouSure) {
    dataRebuttal = [];
    setButtonAreYouSureToFalse();
  }

  const handleSelectSubQuestion = (e) => {
    const value = e.target.value;
    setSelecedOptionForSubQuestion(value);
  };

  const handleRadioChange = (e) => {
    setSelectedRadioOption(e.target.value);
  };

  const cleanUpfunction = () => {
    setSelectedOption("");
    setSelectedRadioOption("");
    setSelecedOptionForSubQuestion("");
    setSelectError("");
  };

  const handleError = (e) => {
    const value = e.target.value;
    setSelectError(e.target.value);
    //   if(value && selectedOption && selectedOptionForSubQuestion
    //     // &&selectedRadioOption==='No'
    //     )
    //  {
    //     setRebuttalDetails(prevValue=>[...prevValue,{
    //         question:selectedOption,
    //         subQuestion:selectedOptionForSubQuestion,
    //         error:value,
    //         sisterComment,
    //         supervisorComment,
    //         auditorComment
    //     }])

    //  }
  };

  useEffect(() => {
    console.log("---------------------");
    console.log(viewQuestions);
    console.log(selectedOption, selectedOptionForSubQuestion);
    const fncntoFindRebuttalRaisedBy = (item, item2) => {
      const objectToFind =
        viewQuestions.find(
          (data) =>
            data.question === item &&
            data.subQuestion === item2 &&
            data.commentCat === "Nurse"
        ) ||
        viewQuestions.find(
          (data) =>
            data.question === item &&
            data.subQuestion === item2 &&
            data.commentCat === "Supervisor"
        );

      if (objectToFind != undefined) {
        console.log(objectToFind);
        setRebuttalRaisedBy(objectToFind["user_name"]);
        setRebuttalRaisedByWhichType(objectToFind["commentCat"]);
      }
      //

      // console.log(objectToFind)
      // return objectToFind['user_name']
    };

    if (viewQuestions.length > 0) {
      fncntoFindRebuttalRaisedBy(selectedOption, selectedOptionForSubQuestion);
    }
    // setRebuttalRaisedBy(fncntoFindRebuttalRaisedBy(selectedOption,selectedOptionForSubQuestion));
  }, [selectedOption, selectedOptionForSubQuestion, viewQuestions.length]);

  useEffect(() => {
    if (statusOfRebuttalPopup == "Update") {
      const dateTimeObject = moment(
        rebuttalFiledOnInUpdate,
        "DD-MMM-YYYY HH:mm:ss A"
      );
      if (viewRebuttalData != undefined)
        console.log(viewRebuttalData["body"][0]["FiledOn"]);
      if (viewRebuttalData != undefined) {
        setRebuttalFiledOnInUpdate(viewRebuttalData["body"][0]["FiledOn"]);
        console.log(dateTimeObject);
        // const year = dateTimeObject.getFullYear();
        // const month = String(dateTimeObject.getMonth() + 1).padStart(2, '0');
        // const day = String(dateTimeObject.getDate()).padStart(2, '0');
        // console.log(day,month,year)
        // const dateOnlyString = `${day}-${month}-${year}`;
        const formattedDate = dateTimeObject.format("DD-MMM-YYYY");
        setDateOnly(formattedDate);
      }
    }
  }, [rebuttalFiledOnInUpdate, isViewRebuttalDataEmpty]);

  const handleSave = () => {
    //  setIsSaveClicked(true);
    //  if(selectError && selectedOption && selectedOptionForSubQuestion
    //     // &&selectedRadioOption==='No'
    //     )
    //  {
    //     setRebuttalDetails(prevValue=>[...prevValue,{
    //         question:selectedOption,
    //         subQuestion:selectedOptionForSubQuestion,
    //         error:selectError,
    //         sisterComment,
    //         supervisorComment,
    //         auditorComment
    //     }])

    //  dataRebuttal.push({
    //   question:selectedOption,
    //   subQuestion:selectedOptionForSubQuestion,
    //   error:selectError,
    //   nurseComment:sisterComment,
    //   supervisorComment:supervisorComment,
    //   auditorComment:auditorComment
    //  })
    let isEntryUpdated = false;
    setIsSaveClicked(true);
    for (let i = 0; i < dataRebuttal.length; i++) {
      if (
        dataRebuttal[i].question === selectedOption &&
        dataRebuttal[i].subQuestion === selectedOptionForSubQuestion
      ) {
        // Entry found, update the values
        dataRebuttal[i].error = selectError;
        dataRebuttal[i].sisterComment = sisterComment;
        dataRebuttal[i].supervisorComment = supervisorComment;
        dataRebuttal[i].auditorComment = auditorComment;

        isEntryUpdated = true;
        break; // Exit the loop once the entry is updated
      }
    }

    // If the entry is not updated, add a new entry
    if (!isEntryUpdated) {
      dataRebuttal.push({
        question: selectedOption,
        questionId:
          dataToPass[selectedOption][selectedOptionForSubQuestion][
            "Question_ID"
          ],
        subQuestion: selectedOptionForSubQuestion,
        error: selectError,
        sisterComment: sisterComment,
        supervisorComment: supervisorComment,
        auditorComment: auditorComment,
      });

      // setDataRebuttal(prevValue=>[...prevValue,
      //   {question: selectedOption,
      //   subQuestion: selectedOptionForSubQuestion,
      //   error: selectError,
      //   sisterComment: sisterComment,
      //   supervisorComment: supervisorComment,
      //   auditorComment: auditorComment}])
    }

    //  setSisterComment('');
    //  setSupervisorComment('');
    //  setAuditorComment('');
    //  }
    //  cleanUpfunction();
  };
  const memoizedViewData = useMemo(() => {
    return viewRebuttalData;
  }, [viewRebuttalData]);

  useEffect(() => {
    let timeoutId;

    if (isSaveClicked) {
      timeoutId = setTimeout(() => {
        setIsSaveClicked(false);
      }, 1000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isSaveClicked]);

  useEffect(() => {
    console.log(isViewRebuttalDataEmpty);
    console.log(viewQuestions);
    console.log(" is the data arrived", !isViewRebuttalDataEmpty);
    console.log("data", viewRebuttalData);
    if (!isViewRebuttalDataEmpty && viewQuestions.length > 0) {
      console.log("////////////////////");
      console.log([...new Set(viewQuestions.map((item) => item["question"]))]);
      setViewQs([...new Set(viewQuestions.map((item) => item["question"]))]);
    }
  }, [isViewRebuttalDataEmpty, viewQuestions.length]);

  useEffect(() => {
    console.log("Colcole for view rebuttal----------->");
    console.log(viewQuestions);
    console.log(viewQs);
    console.log(subQuestions);

    if (viewQs.length > 0 && flag == 1) {
      setSelectedOption(viewQs[0]);
      handleQuestionClick(viewQs[0]);
      setflag(0);
      console.log(" it needs to run for working");
      if (subQuestions.length > 0) setIsExpanded(viewQs[0]);
    }
    // selectedOptionForSubQuestion=viewQuestions.find(item=>item.question==selectedOption);
    console.log(viewQuestions.find((item) => item.question == selectedOption));
    console.log(viewQuestions);
    if (viewQuestions.length > 0)
      setSelecedOptionForSubQuestion(
        viewQuestions.find((item) => item.question == selectedOption)
          ? viewQuestions.find((item) => item.question == selectedOption)[
              "subQuestion"
            ]
          : ""
      );
  }, [viewQuestions.length, viewQs.length, subQuestions.length]);

  useEffect(() => {
    console.log("++++++++++++++++++++++++++++");
    const fetchViewData = async () => {
      // const api_url = `https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_vcareui_clinicalauditrebuttal?taskID=${sessionStorage.getItem(
      //   "ActiveTaskID"
      // )}&user_id=&dispute_id=&dispute_status=&fromDate=&toDate=`;

      try {
        const api = new Api_Call();
        const data = await api.getData(
          `AUDIT-REBUTTAL/DATA?taskID=${sessionStorage.getItem(
            "ActiveTaskID"
          )}&user_id=&dispute_id=&dispute_status=&fromDate=&toDate=`
        );
        console.log("------------------->");

        console.log("Response:", data);
        setViewRebuttalData(data);
        setIsViewRebuttalDataEmpty(false);

        if (data) {
          const viewQuestionFields = data.body.flatMap((item) => {
            return item["user_details"].map((item2) => {
              return {
                question_id: item2["Question_ID"],
                user_name: item2["User_Name"],
                comment: item2["Comment"],
                commentCat: item2["Comment_Category"],
                raisedOn: item2["RaisedOn"],
              };
            });
          });

          console.log(viewQuestionFields);

          const dummyarr = [];
          viewQuestionFields.forEach((item) =>
            questionDetails.forEach((item2) => {
              if (item2["question_id"] == item["question_id"]) {
                dummyarr.push({
                  ...item,
                  question: item2["question"],
                  subQuestion: item2["subQuestion"],
                });
                // dummyarr.push({question:item2['question'],subQuestion:item2['subQuestion'],question_id:item2['question_id']});
              }
            })
          );

          console.log(dummyarr);

          setViewQuestions([...dummyarr]);

          // setIsViewRebuttalDataEmpty(false)
          console.log(dummyarr);
        }
      } catch (error) {
        console.error("Error:", error);
        setIsViewRebuttalDataEmpty(true);
      }

      // fetch(api_url)
      //   .then((response) => response.json())
      //   .then((data) => {
      //     console.log("------------------->");

      //     console.log("Response:", data);
      //     setViewRebuttalData(data);
      //     setIsViewRebuttalDataEmpty(false);

      //     if (data) {
      //       const viewQuestionFields = data.body.flatMap((item) => {
      //         return item["user_details"].map((item2) => {
      //           return {
      //             question_id: item2["Question_ID"],
      //             user_name: item2["User_Name"],
      //             comment: item2["Comment"],
      //             commentCat: item2["Comment_Category"],
      //             raisedOn: item2["RaisedOn"],
      //           };
      //         });
      //       });

      //       console.log(viewQuestionFields);

      //       const dummyarr = [];
      //       viewQuestionFields.forEach((item) =>
      //         questionDetails.forEach((item2) => {
      //           if (item2["question_id"] == item["question_id"]) {
      //             dummyarr.push({
      //               ...item,
      //               question: item2["question"],
      //               subQuestion: item2["subQuestion"],
      //             });
      //             // dummyarr.push({question:item2['question'],subQuestion:item2['subQuestion'],question_id:item2['question_id']});
      //           }
      //         })
      //       );

      //       console.log(dummyarr);

      //       setViewQuestions([...dummyarr]);

      //       // setIsViewRebuttalDataEmpty(false)
      //       console.log(dummyarr);
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error:", error);
      //     setIsViewRebuttalDataEmpty(true);
      //   })
      //   .finally();
    };
    fetchViewData();
    // console.log(viewRebuttalData)
    //   if(viewRebuttalData){

    //     const viewQuestionFields=viewRebuttalData.body.flatMap(item=>{
    //       return item['user_details'].map(item2=>{
    //         return {
    //       question_id:item2['Question_ID'],
    //       user_name:item2['User_Name'],
    //       comment:item2['Comment'],
    //       commentCat:item2['Comment_Category'],
    //       raisedOn:item2['RaisedOn'],

    //        }

    //       }
    //         )
    //     })

    //     console.log(viewQuestionFields)

    //    const dummyarr=[];
    //    viewQuestionFields.forEach(item=>questionDetails.forEach(item2=>{
    //     if(item2['question_id']==item['question_id'])
    //     {
    //       dummyarr.push({...item,question:item2['question'],subQuestion:item2['subQuestion']})
    //       // dummyarr.push({question:item2['question'],subQuestion:item2['subQuestion'],question_id:item2['question_id']});
    //     }
    //   }))

    //      console.log(dummyarr)

    //       setViewQuestions([...dummyarr]);

    //       // setIsViewRebuttalDataEmpty(false)
    // console.log(dummyarr)
    //   }
  }, [isViewRebuttalDataEmpty]);

  useEffect(async () => {
    // const response = await fetch(
    //   `https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_vcareui_clinicalauditrebuttal?taskID=${sessionStorage.getItem(
    //     "ActiveTaskID"
    //   )}&user_id=&dispute_id=&dispute_status=&fromDate=&toDate=`
    // );
    const api = new Api_Call();
    const data = await api.getData(
      `AUDIT-REBUTTAL/DATA?taskID=${sessionStorage.getItem(
        "ActiveTaskID"
      )}&user_id=&dispute_id=&dispute_status=&fromDate=&toDate=`
    );

    // const data = await response.json();
    console.log(data);
    if (data.body.length > 0) {
      setDisputeID(data.body[0]["Dispute_ID"]);
      setDisputeStatus(data.body[0]["Status"]);
      setRaisedOn(data.body[0]["FiledOn"]);
    }
  }, []);

  console.log(raisedOn, disputeID, disputeStatus);

  useEffect(() => {
    console.log("useEffect running");
    console.log(subQuestions);

    if (selectedOption && isViewRebuttalactive && viewRebuttalData) {
      // setSubQuestions([]);
    }

    // else if (selectedOption && !showViewRebuttal || statusOfRebuttalPopup!='View') {
    else if (
      selectedOption &&
      statusOfRebuttalPopup != "View" &&
      statusOfRebuttalPopup != "Update"
    ) {
      setSubQuestions([]);
      const subKeys = Object.keys(dataToPass[selectedOption]);
      console.log(subKeys);

      subKeys.map((item) => {
        if (typeof dataToPass[selectedOption][item] === "object")
          setSubQuestions((prevValue) => [...prevValue, item]);
      });
      // const subQuestionsToSet = subKeys.filter(item => typeof dataToPass[selectedOption][item] === 'object');
      // setSubQuestions(subQuestionsToSet);
    }
  }, [selectedOption]);

  useEffect(() => {
    if (
      showViewRebuttal ||
      (statusOfRebuttalPopup == "View" &&
        viewRebuttalData &&
        selectedOption &&
        selectedOptionForSubQuestion)
      //     // &&selectedRadioOption==='No'
    ) {
      console.log(viewQuestions);
      console.log(
        viewQuestions.filter(
          (item) =>
            item["question"] === selectedOption &&
            item["subQuestion"] === selectedOptionForSubQuestion
        )
      );
      setDataForView(
        viewQuestions.filter(
          (item) =>
            item["question"] === selectedOption &&
            item["subQuestion"] === selectedOptionForSubQuestion
        )
      );
    }

    return () => {
      //   setSelectedOption('');
      //     setSelectedRadioOption('');
      //     setSelecedOptionForSubQuestion('');
    };
  }, [selectedOption, selectedOptionForSubQuestion]);

  // if(selectedOption)
  //   {
  //    const subKeys=Object.keys(dataToPass[selectedOption])
  //    console.log(subKeys);

  //    const subQuestionsToSet=subKeys.filter(item=>
  //     {
  //         console.log(item);
  //         console.log(dataToPass[selectedOption][item])
  //        return typeof dataToPass[selectedOption][item]==='object'})

  //        setSubQuestions((prevValue)=>[...prevValue,subQuestionsToSet])
  //    console.log(subQuestions);

  //   }
  // console.log(selectedOption);

  // console.log(subQuestions);
  // console.log(rebuttalDetails)
  const [isCollasped, setIsCollasped] = useState(false);
  const [expanded, setIsExpanded] = useState(null);

  console.log(expanded);

  // const handleQuestionClick=(item)=>{

  //     setSubQuestions([]);
  //     setSelectedOption(item);

  //     setIsCollasped(false);
  //     const subKeys = Object.keys(dataToPass[item]);
  //     console.log(subKeys);

  //     subKeys.map(item2=> {if(typeof dataToPass[item][item2] === 'object')
  //     setSubQuestions(prevValue=>[...prevValue,item2])});

  // }
  console.log("rebuttal summary", dataRebuttal);

  const handleQuestionClick = (item) => {
    console.log(item);
    // if (expandedItem === item) {
    //   // Collapse the currently expanded item
    //   setIsCollasped(true);
    //   setExpandedItem(null);
    // } else {
    // Expand the clicked item
    //setIsCollasped(false);
    //setExpandedItem(item);
    setHandleClicked(true);
    console.log(showViewRebuttal);
    console.log(viewRebuttalData);
    console.log(showViewRebuttal && viewRebuttalData);
    console.log(
      (statusOfRebuttalPopup == "View" && viewRebuttalData) ||
        statusOfRebuttalPopup == "Update"
    );
    if (
      (statusOfRebuttalPopup == "View" && viewRebuttalData) ||
      statusOfRebuttalPopup == "Update"
    ) {
      console.log("<--------------->");
      console.log(showViewRebuttal);
      console.log(viewRebuttalData);
      console.log(viewQuestions);
      setSubQuestions([]);
      setSelecedOptionForSubQuestion("");
      // You may want to clear subQuestions here or in another suitable place
      setSelectedOption(item);
      setIsExpanded(item);
      viewQuestions.forEach((item2) => {
        if (item2["question"] === item) {
          setSubQuestions((prevValue) => [...prevValue, item2["subQuestion"]]);
        }
      });
    } else {
      console.log("You areJIEDC");

      setSubQuestions([]);
      setSelecedOptionForSubQuestion("");
      // You may want to clear subQuestions here or in another suitable place
      setSelectedOption(item);
      setIsExpanded(item);
      const subKeys = Object.keys(dataToPass[item]);
      subKeys.forEach((item2) => {
        if (typeof dataToPass[item][item2] === "object") {
          setSubQuestions((prevValue) => [...prevValue, item2]);
        }
      });
    }

    // }
  };

  const handleQuestionClickNegative = (item) => {
    setSelectedOption("");
    setIsExpanded(null);
  };

  const handleSubOption = (item) => {
    setSelecedOptionForSubQuestion(item);
    console.log("decision taken", dataToPass[selectedOption][item]["Decision"]);
  };

  const subQuestionsToRender =
    statusOfRebuttalPopup == "Update"
      ? [...new Set(subQuestions)]
      : subQuestions;

  const codeForSubmitRebuttal = (role, rebuttalStatus) => {
    if (role == "Nurse" && rebuttalStatus == "Raise") return 13;

    if (
      role == "Supervisor" &&
      (rebuttalStatus == "Raise" || rebuttalStatus == "Update")
    )
      return 14;

    if (role == "Auditor" && rebuttalStatus == "Update") {
      if (valueFromDropDownAuditor == "Maintained") return 16;
      else if (valueFromDropDownAuditor == "Overtuned for Nurse") return 17;
      else if (valueFromDropDownAuditor == "Overturned for Nurse and Process")
        return 18;
    }
  };

  console.log(subQuestions);

  // if(selectedOption && selectedOptionForSubQuestion)
  // console.log(dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_Type'].filter(item=>item.ID===dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_ID'])[0]['Error'])

  useEffect(() => {
    console.log("inside use effect---");
    setSisterComment("");
    setSupervisorComment("");
    setAuditorComment("");

    const matchingItem = dataRebuttal.find(
      (item) =>
        item.question === selectedOption &&
        item.subQuestion === selectedOptionForSubQuestion
    );

    console.log(matchingItem);
    if (matchingItem) {
      setSisterComment(matchingItem.sisterComment);
      setAuditorComment(matchingItem.auditorComment);
      setSupervisorComment(matchingItem.supervisorComment);
    }

    if (selectedOption && selectedOptionForSubQuestion)
      setQuestionComment(
        dataToPass[selectedOption][selectedOptionForSubQuestion]["Comment"]
      );
  }, [selectedOption, selectedOptionForSubQuestion]);

  useEffect(() => {
    setSisterRebuttalRaisedOnUpdate("");
    setAuditorRebuttalRaisedOnUpdate("");
    setSupervisorRebuttalRaisedOnUpdate("");
    if (statusOfRebuttalPopup == "Update") {
      const matchingItem = viewQuestions.filter(
        (item) =>
          item.question === selectedOption &&
          item.subQuestion === selectedOptionForSubQuestion
      );

      console.log(matchingItem);
      if (matchingItem) {
        matchingItem.map((item) => {
          console.log(item);
          if (item.commentCat == "Nurse") {
            setSisterRebuttalRaisedOnUpdate(item.raisedOn);
            setSisterComment(item.comment);
          }
          if (item.commentCat == "Auditor") {
            setAuditorComment(item.comment);
            setAuditorRebuttalRaisedOnUpdate(item.raisedOn);
          }
          if (item.commentCat == "Supervisor") {
            setSupervisorComment(item.comment);
            setSupervisorRebuttalRaisedOnUpdate(item.raisedOn);
          }
        });
      }
    }
  }, [selectedOption, selectedOptionForSubQuestion]);

  const commentType = (user, item) => {
    if (user == "Nurse") {
      return item.sisterComment;
    } else if (user == "Supervisor") {
      return item.supervisorComment;
    } else if (user == "Auditor") {
      return item.auditorComment;
    }
  };

  console.log(userId);
  const handleSubmit = async () => {
    // setIsViewRebuttalactive(true);
    setIsSubmitclicked(true);
    onClose();
    //  setIsSubmitInRebuttalPressed();
    onSubmitHandler();
    console.log(
      "payload",
      dataRebuttal.map((item) => ({
        question_id: item.questionId,
        comment: commentType(user, item),
      }))
    );
    // setDataRebuttal([]);

    // const api_url =
    //   "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_vcareui_clinicalauditrebuttal";
    const api = new Api_Call();

    const payload = {
      // env: "QA",
      taskID: sessionStorage.getItem("ActiveTaskID"),
      dispute_status: codeForSubmitRebuttal(user, statusOfRebuttalPopup),
      params_info: dataRebuttal.map((item) => ({
        question_id: item.questionId,
        comment: commentType(user, item),
      })),
      user_id: Number(userId),
    };

    // const requestOptions = {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(payload),
    // };

    // fetch(api_url, requestOptions)
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log("------------------->");

    //     console.log("Response:", data);
    //   })
    try {
      const data = await api.postData("AUDIT-REBUTTAL/DATA", payload);
      console.log(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      if (user == "Nurse")
        history.push(
          `${
            menus["nurse"]["menus"].find((item) => item.landingPage === true)[
              "route"
            ]
          }?selectedTile=Audited`
        );
      else if (user == "Supervisor")
        history.push(`/ClinicalHome?selectedTile=Audited`);
      else if (user == "Auditor")
        history.push(
          `${
            menus["auditor"]["menus"].find((item) => item.landingPage === true)[
              "route"
            ]
          }?selectedTile=Audited`
        );
    }

    // toast.success("Rebuttal Submitted Successfully", {
    //   // autoClose: false,
    //   autoClose: 1000,
    //   // Other options...
    // });

    dataRebuttal = [];
  };

  // const handleIsModalClosed=()=>{
  //   setIsModalClosed(true);

  // }
  const questionsToRender =
    statusOfRebuttalPopup == "Update" ? viewQs : questionsFromAuditData;

  // console.log("isModalClosed",isModalClosed);
  console.log(viewQs);

  console.log(questionsToRender);
  if (statusOfRebuttalPopup === "View") {
    // const viewQs=[...new Set(viewQuestions.map(item=>item['question']))];

    console.log();

    // const subQs=viewQuestions.map(item=>item['subQuestion']);
    // console.log(viewQuestions)
    console.log(subQuestions);
    console.log(viewQs);
    console.log(dataToPass);
    console.log(selectedOption, selectedOptionForSubQuestion);
    if (selectedOption && selectedOptionForSubQuestion)
      console.log(
        dataToPass[selectedOption][selectedOptionForSubQuestion]["Error_ID"]
      );
    return (
      <>
        <PopOutModal
          isOpen={isOpen}
          onClose={onClose}
          modalClose={modalClose}
          bigPopUpHeight={true}
          content={
            <>
              <div className="rebuttal--body">
                <div className="rebuttal--heading">
                  View Rebuttal
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      fontSize: "16px",
                    }}
                  >
                    {disputeID && (
                      <span style={{ margin: "2px 0" }}>
                        <b>Dispute ID:</b> {disputeID}
                      </span>
                    )}
                    {disputeStatus && (
                      <span style={{ margin: "2px 0" }}>
                        <b>Dispute Status:</b>
                        {disputeStatus}
                      </span>
                    )}
                    {raisedOn && (
                      <span style={{ margin: "2px 0" }}>
                        <b>Raised On:</b>
                        {raisedOn}
                      </span>
                    )}
                  </div>
                </div>

                <div className="rebuttal--main-container">
                  <div className="rebuttal--main-container__left">
                    {viewQs.map((item) => (
                      <>
                        {/* <div> */}
                        <div
                          style={{
                            border: "1px solid rgba(0, 0, 0, 0.3)",
                            marginBottom: "20px",
                            borderRadius: "5px",
                          }}
                        >
                          <div className="question--container">
                            {item}{" "}
                            {selectedOption === item && expanded === item ? (
                              <button
                                onClick={() =>
                                  handleQuestionClickNegative(item)
                                }
                              >
                                -
                              </button>
                            ) : (
                              <button onClick={() => handleQuestionClick(item)}>
                                +
                              </button>
                            )}
                          </div>

                          <div style={{ display: "flex" }}>
                            {/* <div style={{width:'45%'}}> */}
                            <div
                              style={{
                                width: "45%",
                                paddingLeft: "10px",
                                paddingTop: `${
                                  selectedOption == item ? "30px" : ""
                                }`,
                                paddingBottom: `${
                                  selectedOption == item ? "20px" : ""
                                }`,
                              }}
                            >
                              {subQuestions &&
                                selectedOption === item &&
                                !isCollasped &&
                                expanded === item &&
                                [...new Set(subQuestions)].map((item2, key) => (
                                  // <div onClick={()=>handleSubOption(item2)}>{item2}</div>
                                  // <div style={{display:'flex'}}>
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        position: "relative",
                                      }}
                                    >
                                      <span
                                        style={{
                                          position: "absolute",
                                          top: "50%",
                                          transform: "translate(-50%,-50%) ",
                                          margin: "0 10px",
                                        }}
                                      >
                                        {key % 2 == 0 ? (
                                          <RebuttalUserSvg />
                                        ) : (
                                          <RebuttalRobotSvg />
                                        )}{" "}
                                      </span>{" "}
                                      <div
                                        className={`question--options ${
                                          selectedOptionForSubQuestion === item2
                                            ? "question--options__selected"
                                            : ""
                                        }`}
                                        key={item2}
                                        onClick={() => handleSubOption(item2)}
                                        style={{
                                          display:
                                            selectedOption === item
                                              ? "block"
                                              : "none",
                                          width: "100%",
                                          margin: "10px 30px",
                                        }}
                                      >
                                        {item2}
                                        <div style={{ textAlign: "right" }}>
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            {
                                              dataToPass[selectedOption][item2][
                                                "Decision"
                                              ]
                                            }
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ))}
                            </div>

                            {selectedOption == item &&
                              selectedOptionForSubQuestion && (
                                <div className="question--options__right">
                                  {selectedOption &&
                                    selectedOptionForSubQuestion &&
                                    dataToPass[selectedOption][
                                      selectedOptionForSubQuestion
                                    ]["Error_ID"] !== 0 && (
                                      <div
                                        style={{
                                          color: "red",
                                          marginBottom: "5px",
                                        }}
                                      >
                                        {/* {dataToPass[selectedOption][selectedOptionForSubQuestion]}  */}
                                        Error:{" "}
                                        {
                                          dataToPass[selectedOption][
                                            selectedOptionForSubQuestion
                                          ]["Error_Type"].filter(
                                            (item) =>
                                              item.ID ===
                                              dataToPass[selectedOption][
                                                selectedOptionForSubQuestion
                                              ]["Error_ID"]
                                          )[0]["Error"]
                                        }
                                      </div>
                                    )}

                                  {selectedOption &&
                                    selectedOptionForSubQuestion &&
                                    questionComment && (
                                      <div>Comment:{questionComment}</div>
                                    )}

                                  {selectedOption &&
                                    selectedOptionForSubQuestion &&
                                    dataForView && (
                                      <>
                                        <div className="comments">
                                          {dataForView.map((item) => {
                                            console.log(item.commentCat);
                                            console.log(
                                              item.commentCat === "Nurse"
                                            );

                                            return (
                                              <>
                                                {item.commentCat ===
                                                  "Nurse" && (
                                                  <div className="comment-container">
                                                    <label
                                                      htmlFor="sisterComment"
                                                      className="margin-right"
                                                    >
                                                      Nurse Comment:
                                                    </label>
                                                    <span>{item.comment}</span>

                                                    <div>
                                                      <label
                                                        htmlFor="commentRaisedOn"
                                                        className="margin-right"
                                                      >
                                                        Comment Raised On:
                                                      </label>
                                                      <span>
                                                        {item.raisedOn}
                                                      </span>
                                                    </div>

                                                    <div>
                                                      <label
                                                        htmlFor="rebuttalRaisedBy"
                                                        className="margin-right"
                                                      >
                                                        Rebuttal Raised By:
                                                      </label>
                                                      <span>
                                                        {item["user_name"]}
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}

                                                {item.commentCat ===
                                                  "Supervisor" && (
                                                  <div className="comment-container">
                                                    <label
                                                      htmlFor="supervisorComment"
                                                      className="margin-right"
                                                    >
                                                      Supervisor Comment:
                                                    </label>
                                                    <span>{item.comment}</span>
                                                    <div>
                                                      <label
                                                        htmlFor="commentRaisedOn"
                                                        className="margin-right"
                                                      >
                                                        Comment Raised On:
                                                      </label>
                                                      <span>
                                                        {item.raisedOn}
                                                      </span>
                                                    </div>

                                                    <div>
                                                      <label
                                                        htmlFor="rebuttalRaisedBy"
                                                        className="margin-right"
                                                      >
                                                        Rebuttal Raised By:
                                                      </label>
                                                      <span>
                                                        {item["user_name"]}
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}

                                                {item.commentCat ===
                                                  "Auditor" && (
                                                  <div className="comment-container">
                                                    <label
                                                      htmlFor="auditorComment"
                                                      className="margin-right"
                                                    >
                                                      Auditor Comment:
                                                    </label>
                                                    <span>{item.comment}</span>
                                                    <div>
                                                      <label
                                                        htmlFor="commentRaisedOn"
                                                        className="margin-right"
                                                      >
                                                        Comment Raised On:
                                                      </label>
                                                      <span>
                                                        {item.raisedOn}
                                                      </span>
                                                    </div>

                                                    <div>
                                                      <label
                                                        htmlFor="rebuttalRaisedBy"
                                                        className="margin-right"
                                                      >
                                                        Rebuttal Raised By:
                                                      </label>
                                                      <span>
                                                        {item["user_name"]}
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}
                                              </>
                                            );

                                            {
                                              /* <div className="comment-container">
<label htmlFor="commentRaisedOn" className="margin-right">Comment Raised On:</label>
<span>{dataForView[0].raisedOn}</span>
</div>

<div className="comment-container">
<label htmlFor="rebuttalRaisedBy" className="margin-right">Rebuttal Raised By:</label>
<span>{dataForView[0]['user_name']}</span>
</div>
</div>  */
                                            }
                                          })}
                                        </div>
                                      </>
                                    )}

                                  {/* {selectedOption && selectedOptionForSubQuestion && <div className="rebuttal--main-container__right--buttons">
 
   <span style={{color:'teal'}}>{isSaveClicked ? 'Changes Saved Successfully':''}</span>
   
<button className="rebuttal--main-container__right--buttons-save" onClick={handleSave}>Save</button>



      </div>} */}
                                </div>
                              )}
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </div>
              </div>

              <div>
                {rebuttalDetails.map((item) => (
                  <>
                    <div>{item.error}</div>
                    <div> sister comment: {item.sisterComment}</div>
                    <div> auditor comment: {item.auditorComment}</div>
                    <div>supervisor comment: {item.supervisorComment}</div>
                    <p style={{ marginBottom: "14px" }}></p>
                  </>
                ))}
              </div>
              <div className="toast--submit">
                <ToastContainer />
              </div>
            </>
          }
        ></PopOutModal>
      </>
    );
  }

  // else if(statusOfRebuttalPopup==='Update')
  // {

  //   // const viewQs=[...new Set(viewQuestions.map(item=>item['question']))];

  //   console.log()
  //   // const subQs=viewQuestions.map(item=>item['subQuestion']);
  //   // console.log(viewQuestions)
  //   console.log(subQuestions)
  //   console.log(viewQuestions);
  //   (<>
  //     <PopOutModal isOpen={isOpen} onClose={onClose} modalClose={modalClose} bigPopUpHeight={true} content={<>

  //     <div className="rebuttal--body">
  //     <div className='rebuttal--heading'>
  //      {statusOfRebuttalPopup=='Update'?'Update Rebuttal':'Add Rebuttal'}

  //      {/* <button className="rebuttal--main-container__right--buttons-submit" onClick={handleSubmit}>Submit Rebuttal</button> */}
  //      <button className="rebuttal--main-container__right--buttons-submit" onClick={handleSubmit}>{statusOfRebuttalPopup} Rebuttal</button>
  //    </div>

  //    <div className="rebuttal--main-container" >

  //      <div className="rebuttal--main-container__left">

  //      {questionsFromAuditData.map(item=><>
  //      <div style={{border:'1px solid rgba(0, 0, 0, 0.3)', marginBottom:'20px', borderRadius:'5px'}}>
  //      <div className="question--container">{item} {selectedOption === item && expanded===item ? <button onClick={()=>handleQuestionClickNegative(item)}>-</button>:<button onClick={()=>handleQuestionClick(item)}>+</button>}</div>

  //      <div style={{display:'flex'}}>

  //        <div style={{width:'45%', paddingLeft:'10px',paddingTop:`${selectedOption==item?'30px':''}`,paddingBottom:`${selectedOption==item?'20px':''}` }}>
  //        {/* <div style={{isCertainPropertyTrue?{width: '45%', paddingLeft: '40px', paddingTop: '30px'}:{ width: '45%', paddingLeft: '40px' } }}> */}
  //      {subQuestions && selectedOption===item && !isCollasped && expanded===item &&subQuestions.map((item2,key)=>
  //      // <div onClick={()=>handleSubOption(item2)}>{item2}</div>
  //      // <div style={{display:'flex'}}>
  //      <>
  //      <div >
  //      <div style={{display:"flex",position:'relative'}}>
  //      <span style={{ position:'absolute',top:'50%',transform: "translate(-50%,-50%) scale(1.5)",margin:'0 10px'}}>{key%2==0?<AccountCircleRoundedIcon/>:<SmartToyRoundedIcon/>} </span>
  //      <div

  //                  className={`question--options ${selectedOptionForSubQuestion===item2?'question--options__selected':''}` }
  //                  key={item2}
  //                  onClick={() => handleSubOption(item2)}
  //                  style={{
  //                    display: selectedOption === item ? 'block' : 'none',
  //                    width:'100%',
  //                    margin:'10px 30px'

  //                  }}
  //                >
  //                  {item2}
  //                  <div style={{textAlign:'right'}}><span style={{fontSize:'12px',padding:'4px'}}>{dataToPass[selectedOption][item2]['Decision']}</span></div>
  //                </div>

  //                </div>

  //                </div>
  //  </>

  //  ,

  //      )}

  //      </div>

  //  {selectedOption===item && selectedOptionForSubQuestion && <div className="question--options__right">

  //  {selectedOption && selectedOptionForSubQuestion && dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_ID']!==0 &&
  //  <div style={{color:'red',marginBottom:'5px'}}>
  //  {/* {dataToPass[selectedOption][selectedOptionForSubQuestion]}  */}
  //  Error: {dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_Type'].filter(item=>item.ID===dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_ID'])[0]['Error']}

  //  </div>
  //  }

  //  {selectedOption&& selectedOptionForSubQuestion && questionComment && <div>Comment:{questionComment}</div> }

  //  {selectedOption && selectedOptionForSubQuestion && <>

  //  <div className="comments">
  //  <div className="comment-container">
  //  <label htmlFor="sisterComment">Nurse Comment:</label>

  //  <div >
  //  <textarea
  //  className="comment-box sister--comment"
  //  id="sisterComment"
  //  value={sisterComment}
  //  onChange={(e) => setSisterComment(e.target.value)}
  //  disabled={user==='Nurse'?false:true}
  //  />
  //  </div>

  //  </div>

  //  <div className="comment-container">
  //  <label htmlFor="supervisorComment">Supervisor Comment:</label>
  //  <div >
  //  <textarea
  //  className="comment-box supervisor--comment"
  //  id="supervisorComment"
  //  value={supervisorComment}
  //  onChange={(e) => setSupervisorComment(e.target.value)}
  //  disabled={user==='Supervisor'?false:true}

  //  />
  //  </div>

  //  </div>

  //  <div  className="comment-container">
  //  <label htmlFor="auditorComment">Auditor Comment:</label>
  //  <div>
  //  <textarea
  //  className="comment-box auditor--comment"
  //  id="auditorComment"
  //  value={auditorComment}
  //  onChange={(e) => setAuditorComment(e.target.value)}
  //  disabled={user==='Auditor'?false:true}
  //  />
  //  </div>

  //  </div>
  //  </div>

  //  </>}

  //  {selectedOption && selectedOptionForSubQuestion && <div className="rebuttal--main-container__right--buttons">

  //     <span style={{color:'teal'}}>{isSaveClicked ? 'Changes Saved Successfully':''}</span>

  //  <button className="rebuttal--main-container__right--buttons-save" onClick={handleSave}>Save</button>
  //  {/* <button className="rebuttal--main-container__right--buttons-submit">Submit</button>
  //  </div>*/}

  //        </div>}

  //  </div>}

  //    </div>
  //    </div>

  //      </>)}

  //  </div>

  //  </div>
  //  </div>

  //    <div>
  //      {rebuttalDetails.map(item=>
  //      <>
  //      <div>{item.error}</div>
  //      <div> sister comment: {item.sisterComment}</div>
  //      <div> auditor comment: {item.auditorComment}</div>
  //      <div>supervisor comment: {item.supervisorComment}</div>
  //      <p style={{marginBottom:'14px'}}></p>

  //      </>

  //      )}
  //  </div>
  //  <div className="toast--submit">
  //  <ToastContainer/>
  //  </div>

  //     </>}></PopOutModal>

  //     {/* {isSubmitclicked && <PopOutModal isOpen={isSubmitclicked} onClose={()=>{setIsSubmitclicked(false)}} content='Rebuttal is successfully Submited'></PopOutModal>} */}
  //    <div className="toast"></div>
  //    {!isSubmitclicked && isModalClosed && <PopOutModal isOpen={isModalClosed}></PopOutModal>}

  //  </>)
  // }

  return (
    <>
      <PopOutModal
        isOpen={isOpen}
        onClose={onClose}
        modalClose={modalClose}
        bigPopUpHeight={true}
        content={
          <>
            <div className="rebuttal--body">
              <div className="rebuttal--heading">
                {statusOfRebuttalPopup == "Update"
                  ? "Update Rebuttal"
                  : "Add Rebuttal"}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontSize: "16px",
                  }}
                >
                  {disputeID && (
                    <span style={{ margin: "2px 0" }}>
                      <b>Dispute ID:</b> {disputeID}
                    </span>
                  )}
                  {disputeStatus && (
                    <span style={{ margin: "2px 0" }}>
                      <b>Dispute Status:</b>
                      {disputeStatus}
                    </span>
                  )}
                  {raisedOn && (
                    <span style={{ margin: "2px 0" }}>
                      <b>Raised On:</b>
                      {raisedOn}
                    </span>
                  )}
                </div>

                {statusOfRebuttalPopup == "Update" && user == "Auditor" && (
                  <div
                    style={{
                      textAlign: "end",
                      // flex:'1',
                      color: "#FB4E0B",
                      width: "240px",
                    }}
                  >
                    <select
                      style={{
                        width: "100%",
                        height: "50px",
                        marginRight: "10px",
                      }}
                      value={valueFromDropDownAuditor}
                      onChange={(e) => {
                        setValueFromDropDownAuditor(e.target.value);
                      }}
                      className="statusDropdown"
                    >
                      <option value="">Select</option>
                      <option value="Maintained">Maintained</option>
                      <option value="Overtuned for Nurse">
                        Overtuned for Nurse
                      </option>
                      <option value="Overturned for Nurse and Process">
                        Overturned for Nurse and Process
                      </option>
                    </select>
                  </div>
                )}
                <button
                  className="rebuttal--main-container__right--buttons-submit"
                  onClick={handleSubmit}
                  disabled={user == "Auditor" && valueFromDropDownAuditor == ""}
                >
                  {statusOfRebuttalPopup == "Update" ? "Update" : "Submit"}
                </button>
              </div>

              <div className="rebuttal--main-container">
                <div className="rebuttal--main-container__left">
                  {/* {questionsFromAuditData.map(item=><> */}
                  {questionsToRender.map((item) => (
                    <>
                      <div
                        style={{
                          border: "1px solid rgba(0, 0, 0, 0.3)",
                          marginBottom: "20px",
                          borderRadius: "5px",
                        }}
                      >
                        <div className="question--container">
                          {item}{" "}
                          {selectedOption === item && expanded === item ? (
                            <button
                              onClick={() => handleQuestionClickNegative(item)}
                            >
                              -
                            </button>
                          ) : (
                            <button onClick={() => handleQuestionClick(item)}>
                              +
                            </button>
                          )}
                        </div>

                        <div style={{ display: "flex" }}>
                          <div
                            style={{
                              width: "45%",
                              paddingLeft: "10px",
                              paddingTop: `${
                                selectedOption == item ? "30px" : ""
                              }`,
                              paddingBottom: `${
                                selectedOption == item ? "20px" : ""
                              }`,
                            }}
                          >
                            {/* <div style={{isCertainPropertyTrue?{width: '45%', paddingLeft: '40px', paddingTop: '30px'}:{ width: '45%', paddingLeft: '40px' } }}> */}
                            {/* {subQuestions && selectedOption===item && !isCollasped && expanded===item &&subQuestions.map((item2,key)=> */}

                            {subQuestions &&
                              selectedOption === item &&
                              !isCollasped &&
                              expanded === item &&
                              subQuestionsToRender.map(
                                (
                                  item2,
                                  key // <div onClick={()=>handleSubOption(item2)}>{item2}</div>
                                ) => (
                                  // <div style={{display:'flex'}}>
                                  <>
                                    <div>
                                      <div
                                        style={{
                                          display: "flex",
                                          position: "relative",
                                        }}
                                      >
                                        <span
                                          style={{
                                            position: "absolute",
                                            top: "50%",
                                            transform: "translate(-50%,-50%) ",
                                            margin: "0 10px",
                                          }}
                                        >
                                          {key % 2 == 0 ? (
                                            <RebuttalUserSvg />
                                          ) : (
                                            <RebuttalRobotSvg />
                                          )}{" "}
                                        </span>
                                        <div
                                          className={`question--options ${
                                            selectedOptionForSubQuestion ===
                                            item2
                                              ? "question--options__selected"
                                              : ""
                                          }`}
                                          key={item2}
                                          onClick={() => handleSubOption(item2)}
                                          style={{
                                            display:
                                              selectedOption === item
                                                ? "block"
                                                : "none",
                                            width: "100%",
                                            margin: "10px 30px",
                                          }}
                                        >
                                          {item2}
                                          <div style={{ textAlign: "right" }}>
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                padding: "4px",
                                              }}
                                            >
                                              {
                                                dataToPass[selectedOption][
                                                  item2
                                                ]["Decision"]
                                              }
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ),

                                {
                                  /* <div className="rebuttal--main-container__right">
<div className="rebuttal--main-container__right--error">
{selectedOption&& selectedOptionForSubQuestion && selectedOptionForSubQuestion===item2 && dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_ID']!==0 &&
<>
{/* {dataToPass[selectedOption][selectedOptionForSubQuestion]} 
{dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_Type'].filter(item=>item.ID===dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_ID'])[0]['Error']}

</>
}
</div>
{selectedOption&& selectedOptionForSubQuestion && <div>Comment:</div> }

{selectedOption && selectedOptionForSubQuestion && <>

<div className="comments">
<div className="comment-container">
<label htmlFor="sisterComment">Nurse Comment:</label>
<div >
<textarea
className="comment-box sister--comment"
id="sisterComment"
value={sisterComment}
onChange={(e) => setSisterComment(e.target.value)}
/>
</div>

</div>

<div className="comment-container">
<label htmlFor="supervisorComment">Supervisor Comment:</label>
<div >
<textarea
className="comment-box supervisor--comment"
id="supervisorComment"
value={supervisorComment}
onChange={(e) => setSupervisorComment(e.target.value)}
/>
</div>

</div>

<div  className="comment-container">
<label htmlFor="auditorComment">Auditor Comment:</label>
<div>
<textarea
className="comment-box auditor--comment"
id="auditorComment"
value={auditorComment}
onChange={(e) => setAuditorComment(e.target.value)}
/>
</div>

</div>
</div> 


</>}


{selectedOption && selectedOptionForSubQuestion && <div className="rebuttal--main-container__right--buttons">
<button className="rebuttal--main-container__right--buttons-save">Save</button>
{/* <button className="rebuttal--main-container__right--buttons-submit">Submit</button> 
</div>}

</div> 

 </div> */
                                }
                              )}
                          </div>

                          {selectedOption === item &&
                            selectedOptionForSubQuestion && (
                              <div className="question--options__right">
                                {selectedOption &&
                                  selectedOptionForSubQuestion && (
                                    <>
                                      {statusOfRebuttalPopup == "Update" && (
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            textAlign: "end",
                                            width: "111%",
                                          }}
                                        >
                                          <div style={{ fontWeight: "500" }}>
                                            Filed On:{" "}
                                            <span style={{ fontWeight: "400" }}>
                                              {dateOnly}
                                            </span>
                                          </div>
                                          <div style={{ fontWeight: "500" }}>
                                            Raised By:{" "}
                                            <span style={{ fontWeight: "400" }}>
                                              {rebuttalRaisedBy}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}

                                {selectedOption &&
                                  selectedOptionForSubQuestion &&
                                  dataToPass[selectedOption][
                                    selectedOptionForSubQuestion
                                  ]["Error_ID"] !== 0 && (
                                    <div
                                      style={{
                                        color: "red",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      {/* {dataToPass[selectedOption][selectedOptionForSubQuestion]}  */}
                                      Error:{" "}
                                      {
                                        dataToPass[selectedOption][
                                          selectedOptionForSubQuestion
                                        ]["Error_Type"].filter(
                                          (item) =>
                                            item.ID ===
                                            dataToPass[selectedOption][
                                              selectedOptionForSubQuestion
                                            ]["Error_ID"]
                                        )[0]["Error"]
                                      }
                                    </div>
                                  )}

                                {selectedOption &&
                                  selectedOptionForSubQuestion &&
                                  questionComment && (
                                    <div>Comment:{questionComment}</div>
                                  )}

                                {selectedOption &&
                                  selectedOptionForSubQuestion && (
                                    <>
                                      {/* {statusOfRebuttalPopup=='Update' &&<div style={{fontSize:'12px'}}>
  <div style={{fontWeight:'500'}}>
    Filed On: <span style={{fontWeight:'400'}}>{dateOnly}</span>
  </div>
  <div style={{fontWeight:'500'}}>
    Raised By: <span style={{fontWeight:'400'}}>{rebuttalRaisedBy}</span>
  </div>
</div>} */}

                                      <div className="comments">
                                        <div className="comment-container">
                                          <label htmlFor="sisterComment">
                                            Nurse Comment:
                                          </label>
                                          <div>
                                            {statusOfRebuttalPopup ==
                                              "Update" &&
                                              sisterRebuttalRaisedOnUpdate && (
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    margin: "5px 0",
                                                  }}
                                                >
                                                  {" "}
                                                  Raised On:{" "}
                                                  {sisterRebuttalRaisedOnUpdate}
                                                </div>
                                              )}
                                            <textarea
                                              className="comment-box sister--comment"
                                              id="sisterComment"
                                              value={sisterComment}
                                              onChange={(e) =>
                                                setSisterComment(e.target.value)
                                              }
                                              disabled={
                                                user === "Nurse" ? false : true
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="comment-container">
                                          <label htmlFor="supervisorComment">
                                            Supervisor Comment:
                                          </label>
                                          <div>
                                            {statusOfRebuttalPopup ==
                                              "Update" &&
                                              supervisorRebuttalRaisedOnUpdate && (
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    margin: "5px 0",
                                                  }}
                                                >
                                                  {rebuttalRaisedByWhichType ==
                                                  "Nurse"
                                                    ? "Commented"
                                                    : "Raised"}{" "}
                                                  On:{" "}
                                                  {
                                                    supervisorRebuttalRaisedOnUpdate
                                                  }
                                                </div>
                                              )}
                                            <textarea
                                              className="comment-box supervisor--comment"
                                              id="supervisorComment"
                                              value={supervisorComment}
                                              onChange={(e) =>
                                                setSupervisorComment(
                                                  e.target.value
                                                )
                                              }
                                              disabled={
                                                user === "Supervisor"
                                                  ? false
                                                  : true
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="comment-container">
                                          <label htmlFor="auditorComment">
                                            Auditor Comment:
                                          </label>
                                          <div>
                                            {statusOfRebuttalPopup ==
                                              "Update" &&
                                              auditorRebuttalRaisedOnUpdate && (
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    margin: "5px 0",
                                                  }}
                                                >
                                                  Commented On:{" "}
                                                  {
                                                    auditorRebuttalRaisedOnUpdate
                                                  }
                                                </div>
                                              )}
                                            <textarea
                                              className="comment-box auditor--comment"
                                              id="auditorComment"
                                              value={auditorComment}
                                              onChange={(e) =>
                                                setAuditorComment(
                                                  e.target.value
                                                )
                                              }
                                              disabled={
                                                user === "Auditor"
                                                  ? false
                                                  : true
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}

                                {selectedOption &&
                                  selectedOptionForSubQuestion && (
                                    <div className="rebuttal--main-container__right--buttons">
                                      <span style={{ color: "teal" }}>
                                        {isSaveClicked
                                          ? "Changes Saved Successfully"
                                          : ""}
                                      </span>

                                      <button
                                        className="rebuttal--main-container__right--buttons-save"
                                        onClick={handleSave}
                                      >
                                        Save
                                      </button>
                                      {/* <button className="rebuttal--main-container__right--buttons-submit">Submit</button> 
</div>*/}
                                    </div>
                                  )}
                              </div>
                            )}
                        </div>
                      </div>

                      {/* <div className="rebuttal--main-container__right">
    <div className="rebuttal--main-container__right--error">
    {selectedOption&& selectedOptionForSubQuestion &&  dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_ID']!==0 &&
    <>
    {/* {dataToPass[selectedOption][selectedOptionForSubQuestion]} 
    {dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_Type'].filter(item=>item.ID===dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_ID'])[0]['Error']}
    
    </>
   }
   </div>
   {selectedOption&& selectedOptionForSubQuestion && <div>Comment:</div> }

   {selectedOption && selectedOptionForSubQuestion && <>

<div className="comments">
    <div className="comment-container">
  <label htmlFor="sisterComment">Nurse Comment:</label>
  <div >
  <textarea
  className="comment-box sister--comment"
    id="sisterComment"
    value={sisterComment}
    onChange={(e) => setSisterComment(e.target.value)}
  />
  </div>
 
  </div>

   <div className="comment-container">
  <label htmlFor="supervisorComment">Supervisor Comment:</label>
  <div >
  <textarea
  className="comment-box supervisor--comment"
    id="supervisorComment"
    value={supervisorComment}
    onChange={(e) => setSupervisorComment(e.target.value)}
  />
  </div>
 
  </div>

  <div  className="comment-container">
  <label htmlFor="auditorComment">Auditor Comment:</label>
  <div>
  <textarea
  className="comment-box auditor--comment"
    id="auditorComment"
    value={auditorComment}
    onChange={(e) => setAuditorComment(e.target.value)}
  />
  </div>
 
  </div>
</div> 


</>}


{selectedOption && selectedOptionForSubQuestion && <div className="rebuttal--main-container__right--buttons">
    <button className="rebuttal--main-container__right--buttons-save">Save</button>
    {/* <button className="rebuttal--main-container__right--buttons-submit">Submit</button> */}
                      {/* </div>} */}

                      {/* </div> */}
                    </>
                  ))}
                </div>
                {/* <div className="rebuttal--main-container__right">
    <div className="rebuttal--main-container__right--error">
    {selectedOption&& selectedOptionForSubQuestion &&  dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_ID']!==0 &&
    <>
    {/* {dataToPass[selectedOption][selectedOptionForSubQuestion]} 
    {dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_Type'].filter(item=>item.ID===dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_ID'])[0]['Error']}
    
    </>
   }
   </div>
   {selectedOption&& selectedOptionForSubQuestion && <div>Comment:</div> }

   {selectedOption && selectedOptionForSubQuestion && <>

<div className="comments">
    <div className="comment-container">
  <label htmlFor="sisterComment">Nurse Comment:</label>
  <div >
  <textarea
  className="comment-box sister--comment"
    id="sisterComment"
    value={sisterComment}
    onChange={(e) => setSisterComment(e.target.value)}
  />
  </div>
 
  </div>

   <div className="comment-container">
  <label htmlFor="supervisorComment">Supervisor Comment:</label>
  <div >
  <textarea
  className="comment-box supervisor--comment"
    id="supervisorComment"
    value={supervisorComment}
    onChange={(e) => setSupervisorComment(e.target.value)}
  />
  </div>
 
  </div>

  <div  className="comment-container">
  <label htmlFor="auditorComment">Auditor Comment:</label>
  <div>
  <textarea
  className="comment-box auditor--comment"
    id="auditorComment"
    value={auditorComment}
    onChange={(e) => setAuditorComment(e.target.value)}
  />
  </div>
 
  </div>
</div> 
</>}


{selectedOption && selectedOptionForSubQuestion && <div className="rebuttal--main-container__right--buttons">
    <button className="rebuttal--main-container__right--buttons-save">Save</button>
    {/* <button className="rebuttal--main-container__right--buttons-submit">Submit</button> 
</div>}

</div> */}
              </div>
            </div>
            {/* <form>
    <label for="options">Choose an option:</label>
    <select id="options" name="options" value={selectedOption} onChange={handleSelectChange}>
    <option value="" disabled hidden>
    Select a main question
  </option>
        {/* <option value="Option 1">Option 1</option>
        <option value="Option 2">Option 2</option>
        <option value="Option 3">Option 3</option> 
        {Object.keys(dataToPass).map(item=><option key={item} value={item} >{item}</option>)}
    </select>
    
    <label for="options-sub">Choose an option:</label>
    <select id="options-sub" name="options-sub" value={selectedOptionForSubQuestion} onChange={handleSelectSubQuestion}>
    <option value="" disabled hidden>
    Select a Sub question
  </option>
        {/* <option value="Option 1">Option 1</option>
        <option value="Option 2">Option 2</option>
        <option value="Option 3">Option 3</option> 
        {
        subQuestions.map(item=>
        
            // console.log(subQuestions)
        <option key={item} value={item}>{item}</option>)
        
        
        // <option value={item}>{item}</option>
        }
    </select>

    {/* <div>
      <label>
        <input
          type="radio"
          name="options"
          value="Yes"
        //   checked={selectedOption}
          onChange={handleRadioChange}
          disabled={selectedOptionForSubQuestion===''}
        />
       Yes
      </label>

      <label>
        <input
          type="radio"
          name="options"
          value="No"
        //   checked={selectedOption === 'Option 2'}
          onChange={handleRadioChange}
          disabled={selectedOptionForSubQuestion===''}
        />
       No
      </label>
    </div> 
    
    {
    selectedOption && selectedOptionForSubQuestion 
    //  && selectedRadioOption==='No' 
     &&
    <>
    <label for="options-sub">Choose an option:</label>
    <select id="options-sub" name="options-sub" value={selectError} onChange={handleError}>
    <option value="" disabled hidden>
    Select an error 
  </option>
        {/* <option value="Option 1">Option 1</option>
        <option value="Option 2">Option 2</option>
        <option value="Option 3">Option 3</option> 
        {
        dataToPass[selectedOption][selectedOptionForSubQuestion]['Error_Type'].map(item=>{
        console.log(item);
       return  <option key={item.ID} value={item.Error}>{item.Error}</option>
    })
        
        
        // <option value={item}>{item}</option>
        }
    </select> */}

            {/* <div>
        <div>
      <label htmlFor="sisterComment">Sister Comment:</label>
      <textarea
        id="sisterComment"
        value={sisterComment}
        onChange={(e) => setSisterComment(e.target.value)}
      />
      </div>

       <div>
      <label htmlFor="supervisorComment">Supervisor Comment:</label>
      <textarea
        id="supervisorComment"
        value={supervisorComment}
        onChange={(e) => setSupervisorComment(e.target.value)}
      />
      </div>

      <div>
      <label htmlFor="auditorComment">Auditor Comment:</label>
      <textarea
        id="auditorComment"
        value={auditorComment}
        onChange={(e) => setAuditorComment(e.target.value)}
      />
      </div>
    </div> */}

            {/* <button onClick={handleSave}>Save</button>
    </>
     }
</form>
    </div>

  </div> */}

            <div>
              {rebuttalDetails.map((item) => (
                <>
                  <div>{item.error}</div>
                  <div> sister comment: {item.sisterComment}</div>
                  <div> auditor comment: {item.auditorComment}</div>
                  <div>supervisor comment: {item.supervisorComment}</div>
                  <p style={{ marginBottom: "14px" }}></p>
                </>
              ))}
            </div>
            <div className="toast--submit">
              <ToastContainer />
            </div>
          </>
        }
      ></PopOutModal>

      {/* {isSubmitclicked && <PopOutModal isOpen={isSubmitclicked} onClose={()=>{setIsSubmitclicked(false)}} content='Rebuttal is successfully Submited'></PopOutModal>} */}
      <div className="toast"></div>
      {!isSubmitclicked && isModalClosed && (
        <PopOutModal isOpen={isModalClosed}></PopOutModal>
      )}
    </>
  );
}

export default Rebuttal;
